import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import initVideo, { destroyVideo, extractEmbedSource, dimensionsVideo, unMuteVideo, muteVideo, isVideoMuted } from '../../../utils/embed';
import s from './VideoEmbed.scss';

const VideoEmbed = ({ content, uid, img = null, embedWidth = null, embedHeight = null, setup }) => {
	const videoEmbedSrc = content.url && extractEmbedSource(content.url, `${uid}`);
	const [showMuted, toggleMuted] = useState(true);

	let defaultAspectRatio = 0.5625;
	if (content.aspectRatio) {
		// Non standard format i.e. !== 16:9, 21:9, 4:3 etc
		const contentAspectRatio = content.aspectRatio.indexOf(' ') !== -1 ? content.aspectRatio.slice(0, content.aspectRatio.indexOf(' ')) : content.aspectRatio;
		defaultAspectRatio = contentAspectRatio.split('-').map(Number).reduce((acc, value) => (!acc ? value : (value / acc)), null);
	}
	const [aspectRatio, setAspectRatio] = useState(defaultAspectRatio);

	useEffect(() => {
		initVideo(videoEmbedSrc, uid, { autoplay: 1, loop: 1, mute: 1 });
		dimensionsVideo(videoEmbedSrc, uid).then((d) => {
			setAspectRatio(d.height / d.width);
			return true;
		}).catch(() => { /* No aspect ratio given */ });

		return () => {
			destroyVideo(videoEmbedSrc, uid);
		};
	}, [videoEmbedSrc, uid]);

	const toggleEmbedSound = (e) => {
		e.preventDefault();
		isVideoMuted(videoEmbedSrc, uid).then((isMuted) => {
			if (isMuted) {
				toggleMuted(false);
				unMuteVideo(videoEmbedSrc, uid);
			} else {
				toggleMuted(true);
				muteVideo(videoEmbedSrc, uid);
			}
			return isMuted;
		}).catch(() => { /* Unable to change sound */ });
	};

	const style = embedWidth && embedHeight ? { width: embedWidth, height: embedHeight } : { paddingBottom: `${aspectRatio * 100}%` };

	return (
		<figure className={[s.videoEmbed, (content.caption ? s.videoEmbed__caption : null)].join(' ')} style={style}>
			<a className={s.videoEmbed_clickListener} href="#unmute" onClick={toggleEmbedSound}>
				{
					showMuted && (
						<svg className={s.videoEmbed_clickListener_icon} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
							<path d="M11.760167.537026726C11.760167.333908686 11.6425724.141481069 11.4608352.0559576837 11.2684076-.0402561247 11.0545991-.00818485523 10.8942428.120100223L6.1583853 3.8938196 11.760167 9.49560134 11.760167.537026726 11.760167.537026726zM14.8112138 14.0561359L.913663697.158585746C.705200445-.0498775056.366314031-.0498775056.15785078.158585746-.0506124722.367048998-.0506124722.705935412.15785078.914398664L3.52105791 4.27867483 3.20782851 4.27867483C2.87642539 4.27867483 2.58778396 4.42834076 2.39535635 4.66353007 2.235 4.84526726 2.13878619 5.09114699 2.13878619 5.34771715L2.13878619 9.62388641C2.13878619 10.2118597 2.61985523 10.6929287 3.20782851 10.6929287L5.68800668 10.6929287 10.8942428 14.8515033C10.9904566 14.9263363 11.1080512 14.969098 11.2256459 14.969098 11.3004788 14.969098 11.3860022 14.9477171 11.4608352 14.9156459 11.6425724 14.8301225 11.760167 14.6376949 11.760167 14.4345768L11.760167 12.517784 14.0543318 14.8119488C14.159098 14.9167149 14.2959354 14.969098 14.4327728 14.969098 14.5696102 14.969098 14.7064477 14.9167149 14.8112138 14.8130178 15.0196771 14.6034855 15.0196771 14.2656682 14.8112138 14.0561359z" />
						</svg>
					)
				}
			</a>
			<div className={s.videoEmbed_container} id={`iframe-${videoEmbedSrc}-${uid}`}>{ img }</div>
			{ content.caption && <figcaption className={s.videoEmbed_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText, {}, setup) }} /> }
		</figure>
	);
};

export default hot(module)(VideoEmbed);
